import React from 'react';

import { inject, observer } from 'mobx-react';

import { getChildInject } from '@/utils/instantLoaded/tools';
import Input from './containers/InputFirstLoad';
import Shortcut from './containers/ShortcutFirstLoad';
import { InitStore } from '@/stores/init';
import { UserStore } from '@/stores/user';
import { FirstInitStore } from '@/stores/firstInit';
import { isShortCutNewUI } from '@/utils/experiment/getShortCutUIUXExperiment';

interface Props {
  initStore: InitStore;
  userStore: UserStore;
  firstStore: FirstInitStore;
}

function BottomFixedArea(props: Props) {
  const { userStore, firstStore } = props;

  // 没有拉取配置 且 没有到展示input的超时时间之前 不展示
  if (!userStore.hasFetchedNewABTestingConfigs && !firstStore.canShowInputArea) {
    return null;
  }

  return (
    <div className={`bottom-fixed-area ${isShortCutNewUI() ? 'bottom-fixed-area_new_ui' : ''}`}>
      <Shortcut />
      <Input />
    </div>
  );
}

export default inject(getChildInject('initStore', 'userStore', 'firstStore'))(observer(BottomFixedArea));
